import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpHeaders,HttpParams } from '@angular/common/http';
import { DATOS_API } from 'app/auth/auth.datos';

@Injectable({
  providedIn: 'root'
})

export class RegisterService {

  // private ip = 'http://35.232.140.117:3800';
  private apiUrl = 'http://35.232.140.117:3800/api_empresa/Institutos';

  constructor(
    private httpClient: HttpClient
  ) { }

  public getLevel() {
    return this.httpClient.get(DATOS_API.url + DATOS_API.endpoints.registerUs.getLevel);
    // return this.httpClient.get(this.ip+'/api_empresa/NivelesUsuario',
    // { headers: new HttpHeaders({'Authorization': 'Bearer ' + this.getToken()})});
  }

  public getEnterprises() {
    return this.httpClient.get(DATOS_API.url + DATOS_API.endpoints.registerUs.getEnterprises);
    // return this.httpClient.get(this.ip+'/api_empresa/Empresas',
    // { headers: new HttpHeaders({'Authorization': 'Bearer ' + this.getToken()})});
  }

  public getCompanies(datos:any) {
    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.empresasGET,datos);
    // return this.httpClient.get(this.ip+'/api_empresa/Empresas', { headers: new HttpHeaders({'Authorization': 'Bearer ' + this.getToken()})});
  }

  private getToken():string{
    const token = localStorage.getItem('token');

    return token;
  }

  public registerUser(user: string, password: string,level: number,empresaId: string,insti?: number,defaultVersResult?:boolean,textVersResult?:any){
    let data= {
          "user":user,
          "password":password,
          "level":level,
          "empresaId":empresaId,
          "institutoId":insti,
          "defaultPlt":defaultVersResult,
          "versionPlt":textVersResult,
        }
        console.log('data',data);


        // const httpBody = new HttpParams()
        //       .set('user', user)
        //       .set('password', password)
        //       .set('level', level)
        //       .set('empresaId', empresaId);

        // console.log(data);

    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.registerUs.registerUser, data);
    // return this.httpClient.post(this.ip+'/api_login/register', data,
    // { headers: new HttpHeaders({'Authorization': 'Bearer ' + this.getToken()})});
  }
getUsuariosEmpresas(nomEmpresa:any,instituto:any,bandera:number){
  console.log(nomEmpresa);
  console.log(instituto);
  console.log(bandera);

  return this.httpClient.get(DATOS_API.url + DATOS_API.endpoints.getUsuariosEmpresas+nomEmpresa+"/"+instituto+"/"+bandera);
console.log(DATOS_API.url + DATOS_API.endpoints.getUsuariosEmpresas+nomEmpresa+"/"+instituto);

}

getUsuariosGPTWEmpresas(pag:number,instituto:any,datos?:any){
console.log(datos);

  return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.getUsuariosEmpresasGPTW+pag+"/"+instituto,datos);

}
actualizaUsuariosEmpresas(iduser:any,datos:any){
console.log(datos);
  return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.actualizaInfoUsuarioEmpresa+iduser,datos);
}

deleteUsuarioAdmin(idUsuario){
  console.log('en elservicio:',idUsuario);
  let datos="hola";
return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.deleteUsuariosAdmin+idUsuario,datos);
// console.log(this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.deleteUsuariosAdmin+idUsuario,datos));

}

saveUserAdminSwift(datos:any){
console.log(datos);
  return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.swift.signUpUser,datos);
}

}
